import {
  InfoCircleTwoTone,
  MinusCircleFilled,
  PlusCircleFilled,
} from "@ant-design/icons";
import { Col, Collapse, Flex } from "antd";
import Loading from "components/loading/Loading";
import { apiGetHelps } from "helpers/api/help";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserInfo, showToastError } from "utils";
import "./styles.scss";

const USPV007 = () => {
  const { t } = useTranslation();
  const userInfo = getUserInfo();
  const [loading, setLoading] = useState(0);
  const [helps, setHelps] = useState({
    data: [],
    page: 1,
    total_items: 0,
    total_page: 0,
  });

  const getHelps = (newPage) => {
    setLoading((prev) => prev + 1);
    apiGetHelps({
      page: newPage || helps.page,
      limit: 15,
    })
      .then((res) => {
        setHelps(res);
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  useEffect(() => {
    getHelps();
  }, []);

  return (
    <div className="main-content help-page-container">
      <div className="root-right-header">
        <div className="screen-name">
          {userInfo?.clinic_name + ` ${t("help.noteTitle")}`}
        </div>
      </div>
      <div className="bg-white">
        <div className="screen-title">{t("help.title")}</div>
        <div className="collapse-item-container">
          {helps.data.length > 0
            ? helps.data.map((item) => (
                <Collapse
                  expandIcon={({ isActive }) =>
                    isActive ? (
                      <MinusCircleFilled
                        style={{ fontSize: "25px" }}
                        className="icon-style"
                      />
                    ) : (
                      <PlusCircleFilled
                        style={{ fontSize: "25px" }}
                        className="icon-style"
                      />
                    )
                  }
                  bordered={false}
                  className="collapse-style"
                  items={[
                    {
                      key: item.id,
                      label: item.subject,
                      children: (
                        <div className="div-collapse-container">
                          <div className="div-collapse-subject" dangerouslySetInnerHTML={{__html: item.content}} />
                          
                        </div>
                      ),
                    },
                  ]}
                />
              ))
            : (
              <div className="ant-list-empty-text">データがありません</div>
            )}
        </div>
        <div className="support-container">
          <InfoCircleTwoTone
            style={{ fontSize: "25px" }}
            className="icon-info"
          />
          <div className="support-text">{t("help.support")}</div>
        </div>
        {helps.data.length > 0 && 
        <div className="footer-content">
          <Col style={{ display: "flex" }}>
            {`${helps.page}/${helps.total_page} ${t("pagination")}　`}
            <Flex gap="10px">
              {helps.page > 1 ? (
                <span
                  style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                  onClick={() => {
                    setHelps((prev) => ({ ...prev, page: prev.page - 1 }));
                    getHelps(helps.page - 1);
                  }}
                >
                  ▶
                </span>
              ) : null}
              {helps.page < helps.total_page ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setHelps((prev) => ({ ...prev, page: prev.page + 1 }));
                    getHelps(helps.page + 1);
                  }}
                >
                  ▶
                </span>
              ) : null}
            </Flex>
          </Col>
        </div>
        }
      </div>
      {loading && <Loading />}
    </div>
  );
};

export default USPV007;
